<ca-modal-container data-uit="delete-confirmation-dialog" [modalTitle]="title" [description]="description" (dismiss)="dismiss()">
    <form #deleteConfirmationForm="ngForm" (ngSubmit)="submit()" autocomplete="off">
        <div class="row">
            <div class="col">
                <div class="d-flex flex-column-reverse">
                    <input
                        id="confirmationText"
                        name="confirmationText"
                        type="text"
                        class="form-control"
                        data-uit="delete-confirmation-dialog-input"
                        [(ngModel)]="enteredText"
                        [placeholder]="confirmationText"
                        required
                    />
                    <label for="confirmationText">{{ inputLabel }}</label>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col">
                <button
                    type="submit"
                    class="btn btn-primary w-100"
                    [disabled]="!deleteConfirmationForm.dirty || deleteConfirmationForm.form.invalid || enteredText !== confirmationText"
                    caAutoFocus
                    data-uit="delete-confirmation-dialog-delete-btn"
                >
                    {{ 'GENERAL.DELETE' | translate }}
                </button>
            </div>
        </div>
    </form>
</ca-modal-container>
